import React from 'react';
import { string, func, bool, node } from 'prop-types';
import ClassNames from 'classnames';
import BaseComponent from '../../../.internal/BaseComponent';
import Input from '../../../input/Input';

import './SearchTextInput.scss';

export default class SearchTextInput extends BaseComponent {
  onChangeHandler = e => {
    const { onChange } = this.props;
    const { value } = e.target;

    if (onChange) {
      onChange(value);
    }
  };

  render() {
    const {
      className,
      disabled,
      id,
      name,
      placeholder,
      prefix,
      readOnly,
      style,
      value
    } = this.props;

    const componentClassNames = ClassNames(
      'search-text-input__field',
      prefix && 'search-text-input__field--prefixed',
      className
    );

    return (
      <Input
        value={value}
        wrapperClassName="search-text-input"
        className={componentClassNames}
        id={id}
        name={name}
        onChange={this.onChangeHandler}
        placeholder={placeholder}
        prefix={
          prefix ? (
            <div className="search-text-input__prefix-container">{prefix}</div>
          ) : (
            undefined
          )
        }
        readOnly={readOnly}
        disabled={disabled}
        style={style}
        tabIndex={-1}
      />
    );
  }
}

SearchTextInput.propTypes = {
  value: string.isRequired,
  className: string.isRequired,
  onChange: func.isRequired,
  placeholder: string.isRequired,
  prefix: node,
  readOnly: bool.isRequired,
  disabled: bool.isRequired,
  name: string
};

SearchTextInput.defaultProps = {
  name: '',
  prefix: undefined
};
